import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import BookYourGuide from "./pages/BookYourGuide";
import ExploreIraq from "./pages/ExploreIraq";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Signup from "./pages/Signup";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import GuideProfile from "./pages/GuideProfile";

import { useTranslation } from "react-i18next";

function App() {
	const { i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	return (
		<div className={isRtl ? "rtl" : "ltr"}>
			<Navbar />
			<Routes>
				<Route
					path='/'
					element={<Home />}
				/>
				<Route
					path='BookYourGuide'
					element={<BookYourGuide />}
				/>
				<Route
					path='ExploreIraq'
					element={<ExploreIraq />}
				/>
				<Route
					path='AboutUs'
					element={<AboutUs />}
				/>
				<Route
					path='ContactUs'
					element={<ContactUs />}
				/>

				<Route
					path='guidePage/:id'
					element={<GuideProfile />}
				/>

				<Route
					path='Singup'
					element={<Signup />}
				/>

				<Route
					path='login'
					element={<Login />}
				/>
			</Routes>

			<Footer />
		</div>
	);
}

export default App;
